/** The move-vs-duplicate prompt for a BULK-dragged selection dropped on the
 *  board. Renders nothing until a bulk drop is pending. */
import React from "react";
import DropConflictModal from "../../WbsBoardView/DropConflictModal/DropConflictModal";

interface BulkDrop {
  ids: number[];
  dxDays: number;
  leafKey: string | null;
  lane: number | null;
}

interface Props {
  bulkDrop: BulkDrop | null;
  onMove: () => void;
  onDuplicate: () => void;
  onClose: () => void;
}

const BulkDropFlow: React.FC<Props> = ({ bulkDrop, onMove, onDuplicate, onClose }) => {
  if (!bulkDrop) return null;
  return (
    <DropConflictModal
      count={bulkDrop.ids.length}
      onMove={onMove}
      onDuplicate={onDuplicate}
      onClose={onClose}
    />
  );
};

export default BulkDropFlow;
